module.exports = __webpack_public_path__ + "img/welcome-banner.1e199a7d.png";